import { createFileRoute } from "@tanstack/react-router";
import DashboardApplications from "@/pages/dashboard/Applications";
import ProtectedRoute from "@/components/ProtectedRoute";

export const Route = createFileRoute("/dashboard/applications")({
  component: () => (
    <ProtectedRoute>
      <DashboardApplications />
    </ProtectedRoute>
  ),
});
